import { render, staticRenderFns } from "./ViewFeedMechanism.vue?vue&type=template&id=0247881a&scoped=true&"
import script from "./ViewFeedMechanism.vue?vue&type=script&lang=js&"
export * from "./ViewFeedMechanism.vue?vue&type=script&lang=js&"
import style0 from "./ViewFeedMechanism.vue?vue&type=style&index=0&id=0247881a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247881a",
  null
  
)

export default component.exports